var map = {
	"./b2_p10_clickable.png": 606,
	"./b2_p12_clickable.png": 607,
	"./b2_p13_clickable.png": 608,
	"./b2_p13_clickable_ph.png": 609,
	"./b2_p14_clickable.png": 610,
	"./b2_p16_clickable.png": 611,
	"./b2_p16_clickable_b.png": 612,
	"./b2_p16_clickable_c.png": 613,
	"./b2_p16_clickable_d.png": 614,
	"./b2_p16_clickable_e.png": 615,
	"./b2_p16_clickable_f.png": 616,
	"./b2_p1_clickable.png": 617,
	"./b2_p1_clickable_ph.png": 618,
	"./b2_p1_clickable_tf.png": 619,
	"./b2_p2_clickable.png": 620,
	"./b2_p3_clickable.png": 621,
	"./b2_p3_clickable_ph.png": 622,
	"./b2_p3_clickable_tf.png": 623,
	"./b2_p4_clickable.png": 624,
	"./b2_p5_clickable.png": 625,
	"./b2_p7_clickable.png": 626,
	"./b2_p8_clickable.png": 627,
	"./b2_p8_clickable_b.png": 628,
	"./b2_p8_clickable_ph.png": 629,
	"./b2_p9_clickable.png": 630
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 605;